import React from 'react';
import { XCircleIcon } from 'lucide-react';
export function WhyItFailed() {
  const failures = [{
    title: 'Melatonina en pastillas',
    description: 'Solo trata el síntoma, pero no apaga el ruido mental, dejándote una fatiga pesada al despertar.'
  }, {
    title: 'Ruido blanco y apps de lluvia',
    description: 'Son solo distracciones que tu cerebro aprende a ignorar cuando el cortisol está alto.'
  }, {
    title: 'Contar ovejas',
    description: 'Es una tarea cognitiva que mantiene una parte de tu cerebro activa, evitando que baje la guardia.'
  }, {
    title: 'Dejar las pantallas',
    description: 'Ayuda, pero no detiene el ciclo de pensamientos intrusivos una vez que ya estás en la cama.'
  }];
  return <section className="py-16 md:py-24 bg-slate-800/50 border-y border-slate-800" data-id="element-220">
      <div className="max-w-5xl mx-auto px-4" data-id="element-221">
        <div className="text-center mb-16" data-id="element-222">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-6" data-id="element-223">
            Por qué lo que intentaste{' '}
            <span className="text-red-400" data-id="element-224">NO funcionó</span>
          </h2>
          <p className="text-xl text-slate-300 max-w-2xl mx-auto" data-id="element-225">
            Has estado atacando el problema desde el ángulo equivocado. La mente
            no puede calmar a la mente cuando el cuerpo está en alerta.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-226">
          {failures.map((item, index) => <div key={index} className="bg-slate-900 p-6 rounded-xl border border-slate-700 flex gap-4 items-start hover:border-slate-600 transition-colors" data-id="element-227">
              <XCircleIcon className="w-6 h-6 text-red-400 flex-shrink-0 mt-1" data-id="element-228" />
              <div data-id="element-229">
                <h3 className="text-lg font-bold text-white mb-2" data-id="element-230">
                  {item.title}
                </h3>
                <p className="text-slate-400 leading-relaxed" data-id="element-231">
                  {item.description}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}